import React, { useEffect } from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';

const PrivacyPolicyPage: React.FC = () => {
  useEffect(() => {
    // Update the document title
    document.title = 'Gizlilik Politikası - Akademi Kadro';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Akademi Kadro gizlilik politikası. Kişisel verilerinizin nasıl işlendiği hakkında bilgi edinin.');
    }
    
    // Clean up when component unmounts
    return () => {
      document.title = 'Akademi Kadro - Güncel Haberler';
      if (metaDescription) {
        metaDescription.setAttribute('content', 'Akademi Kadro - Güncel haberler, son dakika gelişmeleri, ekonomi, siyaset, spor, eğitim ve kültür haberleri');
      }
    };
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 } }}>
      <Paper elevation={3} sx={{ p: { xs: 2, sm: 3, md: 4 }, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', fontSize: { xs: '1.75rem', md: '2.125rem' } }}>
          Gizlilik Politikası
        </Typography>
        <Divider sx={{ mb: { xs: 2, md: 4 } }} />
        
        <Typography variant="body1" paragraph>
          Son güncelleme tarihi: 01.05.2023
        </Typography>
        
        <Typography variant="h6" gutterBottom sx={{ mt: { xs: 2, md: 3 }, fontWeight: 'bold' }}>
          1. Giriş
        </Typography>
        <Typography variant="body1" paragraph>
          Akademi Kadro olarak, kullanıcılarımızın gizliliğine saygı duyuyor ve kişisel verilerinizin korunmasını önemsiyoruz. Bu Gizlilik Politikası, sitemizi ziyaret ettiğinizde veya hizmetlerimizi kullandığınızda hangi bilgilerin toplandığını ve bu bilgilerin nasıl kullanıldığını açıklamaktadır.
        </Typography>
        
        <Typography variant="h6" gutterBottom sx={{ mt: { xs: 2, md: 3 }, fontWeight: 'bold' }}>
          2. Toplanan Bilgiler
        </Typography>
        <Typography variant="body1" paragraph>
          Sitemizi ziyaret ettiğinizde veya hizmetlerimizi kullandığınızda aşağıdaki bilgileri toplayabiliriz:
        </Typography>
        <Box component="ul" sx={{ pl: { xs: 1, md: 2 }, mt: 1 }}>
          <Typography component="li" variant="body1" paragraph>
            <strong>Kişisel Bilgiler:</strong> Ad, soyad, e-posta adresi, telefon numarası gibi sizi tanımlayabilecek bilgiler.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            <strong>Kullanım Verileri:</strong> IP adresi, tarayıcı türü, ziyaret ettiğiniz sayfalar, sitede geçirdiğiniz süre gibi bilgiler.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            <strong>Çerezler:</strong> Sitemiz, kullanıcı deneyimini geliştirmek ve siteyi analiz etmek için çerezler kullanmaktadır.
          </Typography>
        </Box>
        
        <Typography variant="h6" gutterBottom sx={{ mt: { xs: 2, md: 3 }, fontWeight: 'bold' }}>
          3. Bilgilerin Kullanılması
        </Typography>
        <Typography variant="body1" paragraph>
          Topladığımız bilgileri aşağıdaki amaçlar için kullanabiliriz:
        </Typography>
        <Box component="ul" sx={{ pl: { xs: 1, md: 2 }, mt: 1 }}>
          <Typography component="li" variant="body1" paragraph>
            Hizmetlerimizi sunmak, geliştirmek ve iyileştirmek
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Kullanıcı destek hizmetleri sağlamak
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Analiz ve istatistik amaçlı olarak
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Güvenlik ve dolandırıcılık tespiti
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Yasal yükümlülüklerimizi yerine getirmek
          </Typography>
        </Box>
        
        <Typography variant="h6" gutterBottom sx={{ mt: { xs: 2, md: 3 }, fontWeight: 'bold' }}>
          4. Bilgilerin Paylaşılması
        </Typography>
        <Typography variant="body1" paragraph>
          Topladığımız bilgileri aşağıdaki durumlarda üçüncü taraflarla paylaşabiliriz:
        </Typography>
        <Box component="ul" sx={{ pl: { xs: 1, md: 2 }, mt: 1 }}>
          <Typography component="li" variant="body1" paragraph>
            Hizmet sağlayıcılarımız ve iş ortaklarımızla (analitik, reklamcılık, ödeme işlemleri gibi)
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Yasal zorunluluk durumunda (mahkeme kararı veya yasal bir talep olduğunda)
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Şirket birleşmesi, satışı veya yeniden yapılandırması durumunda
          </Typography>
        </Box>
        
        <Typography variant="h6" gutterBottom sx={{ mt: { xs: 2, md: 3 }, fontWeight: 'bold' }}>
          5. Veri Güvenliği
        </Typography>
        <Typography variant="body1" paragraph>
          Kişisel verilerinizin güvenliğini sağlamak için çeşitli teknik ve organizasyonel önlemler almaktayız. Ancak, internet üzerinden hiçbir veri iletiminin %100 güvenli olmadığını unutmayınız.
        </Typography>
        
        <Typography variant="h6" gutterBottom sx={{ mt: { xs: 2, md: 3 }, fontWeight: 'bold' }}>
          6. Haklarınız
        </Typography>
        <Typography variant="body1" paragraph>
          6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında aşağıdaki haklara sahipsiniz:
        </Typography>
        <Box component="ul" sx={{ pl: { xs: 1, md: 2 }, mt: 1 }}>
          <Typography component="li" variant="body1" paragraph>
            Kişisel verilerinizin işlenip işlenmediğini öğrenme
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Yanlış veya eksik işlenmiş verilerinizin düzeltilmesini isteme
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Kişisel verilerinizin silinmesini veya yok edilmesini isteme
          </Typography>
        </Box>
        
        <Typography variant="h6" gutterBottom sx={{ mt: { xs: 2, md: 3 }, fontWeight: 'bold' }}>
          7. İletişim
        </Typography>
        <Typography variant="body1" paragraph>
          Gizlilik Politikamız ile ilgili sorularınız veya talepleriniz için aşağıdaki iletişim bilgilerinden bize ulaşabilirsiniz:
        </Typography>
        <Typography variant="body1" paragraph>
          E-posta: akademikadro@gmail.com<br />
          Adres: Çankaya/Ankara
        </Typography>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicyPage; 